import { AngularEditorConfig } from '@kolkov/angular-editor';
export const TEXT_EDITOR: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    maxHeight: '100px',
    minHeight: '100px',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
        [
            'undo',
            'redo',
            'subscript',
            'superscript',
            'justifyLeft',
            'justifyCenter',
            'justifyRight',
            'justifyFull',
            'indent',
            'outdent',
            'fontName'
        ],
        [
            'fontSize',
            'textColor',
            'backgroundColor',
            'customClasses',
            'link',
            'unlink',
            'insertImage',
            'insertVideo',
            'insertHorizontalRule',
            'removeFormat',
            'toggleEditorMode'
        ]
    ]
}